import {getGenericIconUrl} from '@netx/core/utils/getGenericIconUrl';
import type {AnyUppyFile} from '../../types';

export const getUppyFilePreviewSource = (file: AnyUppyFile) =>
	file.preview || getGenericIconUrl(file.extension);
